module.exports = __webpack_public_path__ + "img/headerbanner.bf3b9757.png";